import getConfiguration from './getCurrencyConfiguration';

/**
 * @param {string} value
 */
function getThousandsGroups(value) {
  const GROUP_LENGTH = 3;
  const groups = [];
  const { length } = value;
  const numberOfGroups = Math.ceil(length / GROUP_LENGTH);

  for (let i = 0; i < numberOfGroups; i += 1) {
    groups.unshift(
      value.substring(length - (i * GROUP_LENGTH) - GROUP_LENGTH, length - (i * GROUP_LENGTH)),
    );
  }

  return groups;
}

/**
 * @implements {CurrencyFormatter}
 */
class FallbackCurrencyFormatter {
  /**
   * @param {string} bcp47LanguageTag
   * @param {string} iso4217CurrencyCode
   */
  constructor(bcp47LanguageTag, iso4217CurrencyCode) {
    this.config = getConfiguration(bcp47LanguageTag, iso4217CurrencyCode);
  }

  /**
   * @param {number} amount
   */
  format(amount) {
    const { config } = this;

    const [integerAmount, fractionAmount] = Math.abs(amount).toFixed(2).split('.');

    const thousandGroups = getThousandsGroups(integerAmount);

    let value = thousandGroups.join(config.thousandsSeparator) + config.decimalSeparator + fractionAmount;

    if (config.currencySymbolBefore) {
      value = config.currencySymbol + value;
    } else {
      value += config.currencySymbol;
    }

    return value;
  }
}

export default FallbackCurrencyFormatter;
